module.exports = __webpack_public_path__ + "static/media/kora.189c439f.png";